import React from "react";
import InsuranceItem from "./InsuranceItem";

export default function InsuranceContainer({ insurances, setSelectedInsurance }) {
  return (
    <div>
      {insurances && insurances.length > 0 ? (
        insurances.map((insurance) => <InsuranceItem key={insurance.id} insuranceData={insurance} setSelectedInsurance={setSelectedInsurance} />)
      ) : (
        <div style={{ padding: 20, fontSize: 18 }}>No data</div>
      )}
    </div>
  );
}
